import IntegrationRequestsSearchBar from './components/IntegrationRequestsSearchBar';
import {
  INTEGRATION_API_TITLE,
  INTEGRATION_REQUESTS_PATH,
  INTEGRATION_REQUESTS_TITLE,
} from './config';
import { useIsIntegrationIt } from './hooks';
import IntegrationRequestsTable from './components/IntegrationRequestsTable';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton, NavigateLinks } from '@/components';
import { Add as AddIcon } from '@mui/icons-material';
import { commercePageBreadcrumbs } from '../../config';
import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import {
  DEFAULT_INTEGRATION_REQUEST_FILTERS,
  type IntegrationRequestFilters,
} from '../../models/IntegrationRequest';

const IntegrationRequestsPage = () => {
  const navigate = useNavigate();
  const isIt = useIsIntegrationIt();
  const [filters, setFilters] = useState<IntegrationRequestFilters>(
    DEFAULT_INTEGRATION_REQUEST_FILTERS
  );
  const breadcrumbs = useMemo(() => commercePageBreadcrumbs(navigate), [navigate]);

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks
        actualPage={isIt ? INTEGRATION_API_TITLE : INTEGRATION_REQUESTS_TITLE}
        breadcrumbs={breadcrumbs}
      />
      <div className='flex flex-wrap gap-2.5 justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate(`${INTEGRATION_REQUESTS_PATH}/new`)}
        >
          <AddIcon />
          {isIt ? 'Nueva integración' : 'Nueva solicitud'}
        </GlobalButton>
      </div>
      <IntegrationRequestsSearchBar filters={filters} onSearch={setFilters} />
      <IntegrationRequestsTable filters={filters} />
    </section>
  );
};

export default IntegrationRequestsPage;
